/**
 * Created by Rodrigo Quesada on 04/01/17.
 */
import * as moment from 'moment';
import Moment = moment.Moment;

export class WorkDuration {
    public from?: Moment;
    public to?: Moment;
    public upToPresent?: boolean;

    constructor(jsonData: any = {}) {
        if (jsonData.from) jsonData.from = moment(jsonData.from);
        if (jsonData.to) jsonData.to = moment(jsonData.to);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/common/values/work-duration.class.ts